import { cn } from "@newxsystems/shared";
import { TootImageCarousel } from "../../../../modules/interactive/components/TootImageCarousel/TootImageCarousel";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { getTootSectionSpacing } from "../../../../modules/layout/toot-section-spacing";
import { RichTextHtml } from "../../RichTextHtml";
import type { IImageCarouselBlockProps } from "./ImageCarouselBlock.props";

export const ImageCarouselBlock = ({
  anchorId,
  behavior,
  buttons,
  eyebrow,
  heading,
  items = [],
  parentClass,
  spacing,
  subheading,
}: IImageCarouselBlockProps) => {
  const headingId = heading && anchorId ? `${anchorId}-heading` : undefined;
  if (!eyebrow && !heading && !subheading && !buttons?.length && !items.length) return null;

  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "relative overflow-hidden text-toot-foreground",
        getTootSectionSpacing(spacing),
        parentClass,
      )}
      id={anchorId ?? undefined}
    >
      <div className="toot-container">
        {eyebrow || heading || subheading ? (
          <header className="mb-9 flex max-w-4xl flex-col items-start gap-4 lg:mb-11">
            {eyebrow ? <p className="toot-eyebrow">{eyebrow}</p> : null}
            {heading ? (
              <h2 className="toot-heading-section" id={headingId}>
                {heading}
              </h2>
            ) : null}
            {subheading ? (
              <RichTextHtml className="toot-subheading max-w-2xl" html={subheading} />
            ) : null}
          </header>
        ) : null}
        <TootImageCarousel behavior={behavior ?? undefined} items={items} />
        {buttons?.length ? (
          <div className="mt-8">
            <TootActions actions={buttons} />
          </div>
        ) : null}
      </div>
    </section>
  );
};

ImageCarouselBlock.displayName = "Block::ImageCarouselBlock";
